import { Pipe, PipeTransform } from '@angular/core';
import { Invoice, INVOICE_STATUS_LABEL } from '~gc/domains/invoices';

@Pipe({ name: 'invoiceStatus' })
export class InvoiceStatusPipe implements PipeTransform {
  transform(invoice: Invoice): string {
    return INVOICE_STATUS_LABEL[invoice.status];
  }
}
